import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { getAlertType } from '../../../helpers/alerts';
import { hideNotification } from '../../../store/actions/notification';

class MessagesComponent extends Component {
  onDismiss = () => {
    const { formikProps, hideNotification, onClose } = this.props;

    if (typeof formikProps !== 'undefined') {
      formikProps.setErrors({});
    }

    if (typeof hideNotification === 'function') {
      hideNotification();
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  }

  showErrorMessage = () => {
    const { formikProps, showFlag } = this.props;

    if (showFlag) {
      return true;
    }

    let show = false;

    if (formikProps && formikProps.touched && formikProps.errors) {
      for (let key in formikProps.touched) {
        if (formikProps.touched.hasOwnProperty(key) && formikProps.errors.hasOwnProperty(key))
          show = (show || !!(formikProps.touched[key] && formikProps.errors[key]));
      }
    }

    return show;
  }

  render() {
    const showFlag = this.showErrorMessage();
    const { notificationId, id, ownProps, customMessage, showDismiss, hideFieldsErrors } = this.props;
    let { message, type, color } = this.props;

    if (ownProps && type !== ownProps.type && showFlag) {
      message = null;
    }

    if(hideFieldsErrors && typeof message === 'object'){
      return null;
    }

    let msgs = message || customMessage;

    if (!(showFlag || (msgs && notificationId === id))) return null;

    if (ownProps && ownProps.showFlag) {
      msgs = customMessage || '';
    }

    if (ownProps && ownProps.type) {
      type = ownProps.type;
    }

    if (!color) {
      color = getAlertType(type)
    }

    if (msgs && typeof msgs !== 'string' && !msgs.props) {
      let msgsValues = Object.values(msgs);
      let msgsValuesStrings = [];

      msgsValues.forEach(msgValue => {
        if (Array.isArray(msgValue)) {
          msgValue.forEach(item => {
            if (! msgsValuesStrings.includes(item))
              msgsValuesStrings.push(item);
          })
        }

        if (typeof msgValue === 'string') {
          if (! msgsValuesStrings.includes(msgValue))
          msgsValuesStrings.push(msgValue);
        }
      })

      msgs = msgsValuesStrings;
    }

    return (
      <Alert
        color={ color }
        className={`text-center ${this.props.class ? this.props.class : ''}`}
        id="errors-container"
        toggle={ showDismiss ? this.onDismiss : null }
      >
        {
          msgs && msgs.length > 0 && typeof msgs === 'string' &&
          <div>{msgs}</div>
        }
        {
          msgs && msgs.length > 0 && typeof msgs !== 'string' && msgs.props &&
          Object.keys(msgs).map((keyName, index) => {
            return <div key={keyName}>{msgs[keyName]}</div>
          })

        }
        {
          msgs && typeof msgs !== 'string' && msgs.props &&
          <div>{ msgs }</div>
        }
        {
          msgs && typeof msgs !== 'string' && !msgs.props && (
            Object.keys(msgs).map((key, index) => {
              return <div key={index}>{msgs[key]}</div>
            })
          )
        }
        { this.props.children }
      </Alert>
    );
  }
}

MessagesComponent.defaultProps = {
  showFlag: false,
  notificationId: null,
  id: null,
  customMessage: '',
  showDismiss: true,
  hideFieldsErrors: false
};

const mapStateToProps = (state, ownProps) => ({
  message: state.notification.message,
  type: state.notification.type,
  id: state.notification.notificationId,
  ownProps: ownProps,
});

const mapActionsToProps = {
  hideNotification,
};

const Messages = connect(mapStateToProps, mapActionsToProps)(MessagesComponent);

export { Messages, MessagesComponent };
